import EditableTable from "../../components/table/EditableTable";
import { useCallback, useMemo   } from "react";
import { useTranslation } from "react-i18next";
import {
    TEXT_FIELD_TYPE,
    NUMERIC_FIELD_TYPE,
    DATE_FIELD_TYPE
} from "../../helpers/constants";
import { formatCurrency } from "../../components/common/PriceDisplay";
import TableService from "../../services/tableService";
import { IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DateService from "../../services/dateService";
import RemoveIcon from "@mui/icons-material/Remove";

export const TABLE_NAME = "agrement_overdue_payments_table";
import { UPPERCASE_ALPHABET } from "../../helpers/constants";
import {Grid} from "@mui/material";

export const useAgreementRawPaymentTableFieldsConfig = () => {
    const { t } = useTranslation();

    return [
        {
            name: "tranche_name",
            getValueCallback: (rowData) => rowData.tranche_name,
            label: t("agreements.payment.payment"),
            dataType: TEXT_FIELD_TYPE,
            editable: false,
        },
        {
            name: "due_date",
            getValueCallback: (rowData) => rowData.due_date,
            label: t("agreements.payment.dueDate"),
            dataType: DATE_FIELD_TYPE,
            editable: false,
        },
        {
            name: "agreement_payment_amount",
            getValueCallback: (rowData) => rowData.agreement_payment_amount,
            label: t("agreements.payment.tracheAmount"),
            dataType: NUMERIC_FIELD_TYPE,
            editable: false,
        },
        {
            name: "paid_amount",
            getValueCallback: (rowData) => rowData.paid_amount,
            label: t("agreements.payment.amountPaid"),
            dataType: NUMERIC_FIELD_TYPE,
            editable: false,
        },
        {
            name: "remaining_amount",
            getValueCallback: (rowData) => rowData.remaining_amount,
            label: t("agreements.payment.amountRemaining"),
            dataType: NUMERIC_FIELD_TYPE,
            editable: false,
        },
        // {
        //     name: "agreement_payment_parent_amount",
        //     getValueCallback: (rowData) => rowData.agreement_payment_parent_amount,
        //     label: t("agreements.payment.parentTracheAmount"),
        //     dataType: NUMERIC_FIELD_TYPE,
        //     editable: false,
        // },
    ];
};



function AgreementRawPayments(props) {
    const { payments } = props
 
    const TABLE_CONFIG = useAgreementRawPaymentTableFieldsConfig()

  const paymentsData = useMemo(
    () =>
      payments
        ? TableService.getFieldsConfigForEditableTable(
          TABLE_CONFIG,
          payments,
          {},
          ()=>{},
          ()=>{},
        )
        : [],
    [payments, TABLE_CONFIG]
  );

  return (
        <EditableTable
          data={paymentsData}
          isLoading={false}
          showTableLoader={false}
          readOnly={false}
          editable={false}
          showCheckbox={false}
          showCleanFilterIcon={false}
          onDataChange={()=>{}}
          onBlur={() => { }}
          style={{
            maxHeight: "100vh",
          }}
          tableConfig={TABLE_CONFIG}
          showContextMenu={false}
          withParamsComparision={false}
          showExportToFileButton={false}
          enableExport={false}
        />
  )
}

export default AgreementRawPayments